import React from 'react'
import { Card, Divider, Flex, Tag } from 'antd'
import { t } from 'i18next'
import dayjs from 'dayjs'

export function onlyUnique (value, index, array) {
  return array.indexOf(value) === index
}

export const JOBS = ['cleaning', 'maintenance', 'municipacility', 'hospital', 'territory_responsable', 'emergency']

export function stripHtml (html) {
  const tmp = document.createElement('DIV')
  tmp.innerHTML = html
  return tmp.textContent || tmp.innerText || ''
}

export function slotTitle (slot) {
  if (slot.type === 'CleaningSlot') {
    return `[Nettoyage] ${slot.name}`
  } else if (slot.type === 'MaintenanceSlot') {
    return `[Maintenace] ${slot.name}`
  } else if (slot.type === 'PatientSlot') {
    return `${slot.name}`
  }
}

export function tagFormat (tag, type) {
  let path = ''
  if (type === 'businessArea') {
    path = 'Admin.Tag.businessArea'
  } else if (type === 'family') {
    path = 'Admin.Tag.family'
  } else if (type === 'tag') {
    path = 'Admin.Tag'
  }
  return <Tag key={tag.id} color={tag.color} variant='solid'>{t(`${path}.${tag.name}`)}</Tag>
}

function displayedTagsHierarchy (displayedTags, displayTag = false) {
  const hierarchy = {}
  displayedTags.forEach((tag) => {
    if (hierarchy[tag.family.business_area.id] === undefined) {
      hierarchy[tag.family.business_area.id] = { businessArea: tag.family.business_area, families: [], tags: [] }
    }
    if (!hierarchy[tag.family.business_area.id].families.map((e) => e.id).includes(tag.family.id)) {
      hierarchy[tag.family.business_area.id].families.push(tag.family)
    }
    if (displayTag) {
      hierarchy[tag.family.business_area.id].tags.push(tag)
    }
  })
  return hierarchy
}

function hierarchyToHtmlTag (hierarchy) {
  const hierarchyFormat = []
  for (const key in hierarchy) {
    const businessArea = hierarchy[key].businessArea
    const families = hierarchy[key].families
    const tags = hierarchy[key].tags
    let hierarchyTags = families.map((family) => (tagFormat(family, 'family')))
    if (tags.length !== 0) {
      hierarchyTags = hierarchyTags.concat(tags.map((tag) => (tagFormat(tag, 'tag')))).flat()
    }
    hierarchyTags.unshift(tagFormat(businessArea, 'businessArea'))
    hierarchyFormat.push(hierarchyTags)
  }
  return hierarchyFormat
}

export function displayHierarchy (displayedTags, displayTag = false) {
  if (displayedTags?.length === 0) {
    return t('Admin.Event.noTags')
  } else {
    return hierarchyToHtmlTag(displayedTagsHierarchy(displayedTags, displayTag)).map((tags, index) => (
      <div key={`div-${index}`}>
        {tags}
      </div>
    ))
  }
}

export function displayBoxEmptyFields (fields) {
  return fields.map((field) => (<div key={field}>- {t(`Admin.BoxList.table.${field}`)}</div>))
}

export function Logs ({ entries, title }) {
  const entryRender = (entry) => (
    <Flex align='center' gap='middle' key={entry.id}>
      <Tag color={entry.color} variant='solid'>
        <span style={{ fontFamily: 'sans-serif', fontWeight: 'bold' }}>
          {dayjs(entry.created_at).format('HH:mm:ss')}
        </span>
      </Tag>
      {entry.display}
    </Flex>
  )

  const header = <Flex align='center' gap='middle' vertical style={{ padding: '1em 0' }}>
    <div style={{ fontSize: '22px' }}>{t('Admin.Common.Logs.header')}</div>
    {title}
  </Flex>
  const elements = entries.flatMap((entry, index) => [<Divider key={`divider-${index}`} />, entryRender(entry)]).slice(1)

  return (
    <Card title={header} style={{ maxHeight: '45em', overflowY: 'scroll' }} >
      <Flex vertical>
        {elements}
      </Flex>
    </Card>
  )
}
